import { MijnRoute } from '../../mijn-navigatie.model';

export const INCASSO_BATCHES_UITVALRAPPORTAGES: MijnRoute = {
    path: 'uitvalrapportages',
    navigationEvent: 'toIncassobatchesUitvalrapportages',
    regex: /^\/incassobatches\/uitvalrapportages$/,
    webcomponent: 'mijn-incassobatches-webcomponent',
    internalPath: '/uitvalrapportages'
};
